import { Component, ChangeDetectionStrategy, ViewEncapsulation, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FikoYTKokBilesenComponent } from '@service/kok-bilesen/kok-bilesen.component';
import { PanoDurumService } from '@uygulamalar/hmi-pano/services/pano-durum.service';
import { UygulamaErisimService } from '@/src/app/shared/abonelik/uygulama-erisim.service';

interface IUygulamaKart {
  baslik: string;
  aciklama: string;
  ikon: string;
  route: string;
  renk: string;
  gradient: string;
  yetkiler?: string[];
  lisans?: string;   // 📟 alt özellik id (lisanslıysa kilitlenir)
}

@Component({
  selector: 'hmi-pano-personel-ana-sayfa',
  standalone: true,
  imports: [CommonModule, RouterModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  templateUrl: './ana-sayfa.component.html',
  styleUrl: './ana-sayfa.component.less',
})
export class HmiPanoPersonelAnaSayfaComponent extends FikoYTKokBilesenComponent {
  constructor() { super(); }
  durum = inject(PanoDurumService);
  private erisim = inject(UygulamaErisimService);

  readonly kartlar: IUygulamaKart[] = [
    // { baslik: 'Puantaj', aciklama: 'Giriş/çıkış ve mesai takibi', ikon: '⏱️', route: 'puantaj', renk: '#1677ff', gradient: 'linear-gradient(135deg, #1e3a5f 0%, #1677ff 100%)' },
    // { baslik: 'PDKS Rapor', aciklama: 'Aylık özet ve raporlar', ikon: '📊', route: 'rapor', renk: '#52c41a', gradient: 'linear-gradient(135deg, #064e3b 0%, #52c41a 100%)' },
    // { baslik: 'Personel Yönetimi', aciklama: 'Personel listesi ve düzenleme', ikon: '👥', route: 'yonetim', renk: '#722ed1', gradient: 'linear-gradient(135deg, #312e81 0%, #722ed1 100%)', yetkiler: ['Süper Yönetici', 'Super Yonetici'] },
    { baslik: 'Projeler', aciklama: 'Proje takibi ve yönetimi', ikon: '📁', route: 'projeler', renk: '#fa8c16', gradient: 'linear-gradient(135deg, #7c2d12 0%, #fa8c16 100%)', lisans: 'projeler' },
    { baslik: 'Üretim', aciklama: 'İş emri, kalite kontrol, üretim takibi', ikon: '⚙️', route: 'uretim', renk: '#f5222d', gradient: 'linear-gradient(135deg, #7f1d1d 0%, #f5222d 100%)', lisans: 'uretim' },
    { baslik: 'Satış', aciklama: 'Sipariş, teklif, müşteri yönetimi', ikon: '🛒', route: 'satis', renk: '#ff9800', gradient: 'linear-gradient(135deg, #e65100 0%, #ff9800 100%)', lisans: 'satis' },
    { baslik: 'Yönetim', aciklama: 'Personel, departman, tedarikçi', ikon: '🏢', route: 'yonetim-kayit', renk: '#722ed1', gradient: 'linear-gradient(135deg, #4a148c 0%, #722ed1 100%)', lisans: 'yonetim' },
    { baslik: 'Posta', aciklama: 'Firma mail kutusunu goruntule', ikon: '📧', route: 'posta', renk: '#1890ff', gradient: 'linear-gradient(135deg, #0c4a6e 0%, #1890ff 100%)', lisans: 'posta' },
  ];

  kartGorunurMu(kart: IUygulamaKart): boolean {
    if (!kart.yetkiler?.length) return true;
    const kullaniciYetkileri = this.durum.kisiYetkileri();
    return kart.yetkiler.some(y => kullaniciYetkileri.includes(y));
  }

  /** Kart alt özelliği lisanslı mı (köprü/izin yoksa AÇIK — geriye uyumlu). */
  lisansli(kart: IUygulamaKart): boolean {
    if (!kart.lisans) return true;
    return this.erisim.altOzellikAcikSenk('📟', kart.lisans);
  }
}
